const state = {
  inProgress: {}, 
  workOrderPostRequest: {},
  taskOutcomes: {},
  assignmentsPostRequest: {},
  currentAssignment: {},
  // current order is order marked to appear in alert or modal
  currentWorkOrder: {},
  workOrderStartingProgress: {
    id: '',
    object: {}
  },
  runningWorkOrder: '',
  workOrderToRemove: '',
  timerToRemove: null,
  timerToReset: null,
  runningPMTimer: null,
  timerSeconds: null,
  otherPausedTimer: null,
  assignmentToRemove: '',
  supportInfo: {},
  procedureId: null,
  teams: {},
  currentSchedule: {},
  newSchedulePostRequest: null,
  refreshingTasks: false,
  startingSubmission: false,
  checkingOffTasks: null,
  timerDirective: null,
  procedures: [],
};
const getters = {
  workOrdersInProgress: state => state.inProgress,
  getWorkOrderPostRequest: state => state.workOrderPostRequest,
  getTaskOutcomes: state => state.taskOutcomes,
  getAssignmentsPostRequest: state => state.assignmentsPostRequest,
  getCurrentPMAssignment: state => state.currentAssignment,
  getCurrentPMWorkOrder: state => state.currentWorkOrder,
  getWorkOrderStartingProgress: state => state.workOrderStartingProgress,
  getRunningPMTimer: state => state.runningPMTimer,
  currentlyRunningPMTimer: state => {
    if (!state.runningPMTimer) return null
    let isPaused = state.runningPMTimer?.isPaused
    return isPaused ? null : state.runningPMTimer.id
  },
  timerPMSeconds: state => state.timerSeconds,
  getRemovedWorkOrder: state => state.workOrderToRemove,
  getRemovedTimer: state => state.timerToRemove,
  getResetPMTimer: state => state.timerToReset,
  getOtherPausedTimer: state => state.otherPausedTimer,
  getRemovedAssignment: state => state.assignmentToRemove,
  getSupportInfo: state => state.supportInfo,
  getProcedureId: state => state.procedureId,
  getCurrentSchedule: state => state.currentSchedule,
  getNewSchedulePostRequest: state => state.newSchedulePostRequest,
  refreshingTasksData: state => state.refreshingTasks,
  startingPMSubmission: state => state.startingSubmission,
  checkingOffTasks: state => state.checkingOffTasks,
  getTimerDirective: state => state.timerDirective,
  getProcedures: state => state.procedures,
  procedureOptions: state => {
    let options = [{ id: "", name: "All" }]
    for (let procedure of state.procedures) {
      options.push({ id: procedure.id, name: procedure.name })
    }
    return options
  },
  getWorkOrderModalInputs: (state, getters) => {
    return {
      settings: {
        viewOnly: {
          bool: true,
          excludeFields: {
            "scheduled_timestamp": true,
            "due_date_timestamp": true,
            "images": true
          },
        },
      },
      inputs: {
        description: {
          type: "text",
          label: "Description",
        },
        scheduled_timestamp: {
          type: "datetime",
          label: "Scheduled for",
          viewOnly: false
        },
        status: {
          type: "text",
          label: "Status",
          capitalize: true
        },
        site_team_id: {
          type: "team",
          label: "Team",
        },
        asset_id: {
          type: "dropdown",
          label: "Asset",
          options: getters.assetOptions,
        },
        due_date_timestamp: {
          type: "datetime",
          label: "Due Date",
          viewOnly: false
        },
        completed_timestamp: {
          type: "datetime",
          label: "Completed Date",
        },
      }
    }
  },
  getPreventiveModalInputs: (state, getters) => {
    let obj = JSON.parse(JSON.stringify(getters.getWorkOrderModalInputs))
    let editAccess = getters.getIsTenantSuperuser
      || getters.getUserPermissions.site_track?.preventive_maintenance?.all_work_orders?.edit_modal?.object?.update_bool
    obj.inputs.scheduled_timestamp.viewOnly = !editAccess
    obj.inputs.due_date_timestamp.viewOnly = !editAccess
    obj.inputs.procedure_id = {
      type: "dropdown",
      label: "Procedure",
      options: getters.procedureOptions
    }
    obj.inputs.images = {
      type: "images",
      viewOnly: !editAccess
    }
    return obj
  },
};
const actions = {
  setProcedures({commit, state}, arr) {
    state.procedures = arr
    commit("setValueLoaded", "procedures")
  }
};
const mutations = {
  setWorkOrderPostRequest(state, [id, request]) {
    state.workOrderPostRequest[id] = request
  },
  resetWorkOrderPostRequest(state) {
    state.workOrderPostRequest = {}
  },
  setTaskOutcomes(state, [workOrderId, taskId, val]) {
    if (!state.taskOutcomes[workOrderId]) state.taskOutcomes[workOrderId] = {}
    state.taskOutcomes[workOrderId][taskId] = val
  },
  resetTaskOutcomes(state) {
    state.taskOutcomes = {}
  },
  setAssignmentsPostRequest(state, [id, request]) {
    state.assignmentsPostRequest[id] = request
  },
  resetAssignmentsPostRequest(state) {
    state.assignmentsPostRequest = {}
  },
  setCurrentPMAssignment(state, [id, object]) {
    state.currentAssignment = {[id]: object}
  },
  setWorkOrdersInProgress(state, obj) {
    state.inProgress = obj
  },
  updateWorkOrderOwner(state, [workOrderId, updatedData]) {
    state.inProgress[workOrderId].employee_id = updatedData.employee.toString()
    state.inProgress[workOrderId].elapsed_time = updatedData.current_timer_seconds
  },
  startWorkOrderProgress(state, workOrder) {
    let id = workOrder.id
    // ensure elapsed_time data is present
    if (!workOrder.elapsed_time) workOrder.elapsed_time = 0
    state.workOrderStartingProgress['object'] = workOrder
    state.workOrderStartingProgress['id'] = id
    state.inProgress[workOrder.id] = workOrder
  },
  removeStartingWorkOrder(state) {
    state.workOrderStartingProgress = {}
  },
  setRunningPMTimer(state, timer) {
    state.runningPMTimer = timer
  },
  setPMTimerSeconds(state, [seconds, id, isPaused]) {
    state.timerSeconds = { seconds: seconds, id: id, isPaused: isPaused }
  },
  setWorkOrderToRemove(state, id) {
    state.workOrderToRemove = id
  },
  setTimerToRemove(state, id) {
    state.timerToRemove = id
  },
  setPMTimerToReset(state, id) {
    state.timerToReset = id
  },
  setOtherPausedTimer(state, obj) {
    state.otherPausedTimer = obj
  },
  setAssignmentToRemove(state, id) {
    state.assignmentToRemove = id
  },
  setCurrentPMWorkOrder(state, object) {
    state.currentWorkOrder = object
  },
  setSupportInfo(state, object) {
    state.supportInfo = object
  },
  setProcedureId(state, id) {
    state.procedureId = id
  },
  setCurrentSchedule(state, schedule) {
    state.currentSchedule = schedule
  },
  setNewSchedulePostRequest(state, object) {
    state.newSchedulePostRequest = object
  },
  refreshPMTasks(state, bool) {
    state.refreshingTasks = bool
  },
  checkOffLastTasks(state, id) {
    state.checkingOffTasks = id
  },
  startPMSubmission(state, bool) {
    state.startingSubmission = bool
  },
  setTimerDirective(state, str) {
    state.timerDirective = str
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};